import hs_1_1 from '../media/homestay/pchome/1.png';
import hs_1_2 from '../media/homestay/pchome/2.jpg';
import hs_1_3 from '../media/homestay/pchome/5.png';
import hs_1_4 from '../media/homestay/pchome/4.jpg';
import hs_1_5 from '../media/homestay/pchome/6.jpg';
import hs_1_6 from '../media/homestay/pchome/7.jpg';
import hs_1_7 from '../media/homestay/pchome/8.jpg';
import hs_1_8 from '../media/homestay/pchome/9.jpg';

import hs_2_1 from '../media/homestay/pearlvalley/1.jpg';
import hs_2_2 from '../media/homestay/pearlvalley/2.jpg';
import hs_2_3 from '../media/homestay/pearlvalley/3.jpg';
import hs_2_4 from '../media/homestay/pearlvalley/4.jpg';
import hs_2_5 from '../media/homestay/pearlvalley/5.jpg';
import hs_2_6 from '../media/homestay/pearlvalley/6.jpg';
import hs_2_7 from '../media/homestay/pearlvalley/7.jpg';
import hs_2_8 from '../media/homestay/pearlvalley/8.jpg';
import hs_2_9 from '../media/homestay/pearlvalley/9.jpg';


import hs_4_1 from '../media/homestay/rainbird/1.jpg';
import hs_4_2 from '../media/homestay/rainbird/2.jpg';
import hs_4_3 from '../media/homestay/rainbird/3.jpg';
import hs_4_4 from '../media/homestay/rainbird/4.jpg';
import hs_4_5 from '../media/homestay/rainbird/5.jpg';
import hs_4_6 from '../media/homestay/rainbird/6.jpg';
import hs_4_7 from '../media/homestay/rainbird/7.jpg';
import hs_4_8 from '../media/homestay/rainbird/8.jpg';
import hs_4_9 from '../media/homestay/rainbird/9.jpg';
import hs_4_10 from '../media/homestay/rainbird/10.jpg';

import hs_5_1 from '../media/homestay/raxidijungle/1.jpeg';
import hs_5_2 from '../media/homestay/raxidijungle/2.jpeg';
import hs_5_3 from '../media/homestay/raxidijungle/3.jpeg';
import hs_5_4 from '../media/homestay/raxidijungle/4.jpeg';
import hs_5_5 from '../media/homestay/raxidijungle/5.jpeg';
import hs_5_6 from '../media/homestay/raxidijungle/6.jpeg';
import hs_5_7 from '../media/homestay/raxidijungle/7.jpeg';
import hs_5_8 from '../media/homestay/raxidijungle/8.jpeg';
import hs_5_9 from '../media/homestay/raxidijungle/9.jpeg';

import hs_7_1 from '../media/homestay/sankula/1.jpg';
import hs_7_2 from '../media/homestay/sankula/2.jpg';
import hs_7_3 from '../media/homestay/sankula/3.jpg';
import hs_7_4 from '../media/homestay/sankula/4.jpg';
import hs_7_5 from '../media/homestay/sankula/5.jpg';
import hs_7_6 from '../media/homestay/sankula/6.jpg';
import hs_7_7 from '../media/homestay/sankula/7.jpg';
import hs_7_8 from '../media/homestay/sankula/8.jpg';

import hs_8_1 from '../media/homestay/simplecamp/1.jpg';
import hs_8_2 from '../media/homestay/simplecamp/2.jpg';
import hs_8_3 from '../media/homestay/simplecamp/3.jpg';
import hs_8_4 from '../media/homestay/simplecamp/4.jpg';
import hs_8_5 from '../media/homestay/simplecamp/5.jpg';
import hs_8_6 from '../media/homestay/simplecamp/6.jpg';

import hs_9_1 from '../media/homestay/swastha/1.jpg';
import hs_9_2 from '../media/homestay/swastha/2.jpg';
import hs_9_3 from '../media/homestay/swastha/3.jpg';
import hs_9_4 from '../media/homestay/swastha/4.jpg';
import hs_9_5 from '../media/homestay/swastha/5.jpg';

import hs_10_1 from '../media/homestay/tuskervally/1.jpeg';
import hs_10_2 from '../media/homestay/tuskervally/2.jpeg';
import hs_10_3 from '../media/homestay/tuskervally/3.jpeg';
import hs_10_4 from '../media/homestay/tuskervally/4.jpeg';
import hs_10_5 from '../media/homestay/tuskervally/5.jpeg';
import hs_10_6 from '../media/homestay/tuskervally/6.jpg';

import hs_11_1 from '../media/homestay/veeras/1.png';
import hs_11_2 from '../media/homestay/veeras/2.png';
import hs_11_3 from '../media/homestay/veeras/3.png';
import hs_11_4 from '../media/homestay/veeras/4.png';
import hs_11_5 from '../media/homestay/veeras/5.jpg';

import hs_12_1 from '../media/homestay/atavi/1.jpg';
import hs_12_2 from '../media/homestay/atavi/2.jpg';
import hs_12_3 from '../media/homestay/atavi/3.jpg';
import hs_12_4 from '../media/homestay/atavi/4.jpg';
import hs_12_5 from '../media/homestay/atavi/5.jpg';

import hs_13_1 from '../media/homestay/baan/1.jpg';
import hs_13_2 from '../media/homestay/baan/2.jpg';
import hs_13_3 from '../media/homestay/baan/3.jpg';
import hs_13_4 from '../media/homestay/baan/4.jpg';
import hs_13_5 from '../media/homestay/baan/5.jpg';
import hs_13_6 from '../media/homestay/baan/6.jpg';

import hs_14_1 from '../media/homestay/bidirinakadu/1.jpg';
import hs_14_2 from '../media/homestay/bidirinakadu/2.jpg';
import hs_14_3 from '../media/homestay/bidirinakadu/3.jpg';
import hs_14_4 from '../media/homestay/bidirinakadu/4.jpg';
import hs_14_5 from '../media/homestay/bidirinakadu/5.jpg';
import hs_14_6 from '../media/homestay/bidirinakadu/6.jpg';

import hs_15_1 from '../media/homestay/brindhavan/1.jpg';
import hs_15_2 from '../media/homestay/brindhavan/2.jpg';
import hs_15_3 from '../media/homestay/brindhavan/3.jpg';
import hs_15_4 from '../media/homestay/brindhavan/4.jpg';
import hs_15_5 from '../media/homestay/brindhavan/5.jpg';
import hs_15_6 from '../media/homestay/brindhavan/6.jpg';
import hs_15_7 from '../media/homestay/brindhavan/7.jpg';
import hs_15_8 from '../media/homestay/brindhavan/8.jpg';

import hs_16_1 from '../media/homestay/cardamom/1.jpg';
import hs_16_2 from '../media/homestay/cardamom/2.jpg';
import hs_16_3 from '../media/homestay/cardamom/3.jpg';
import hs_16_4 from '../media/homestay/cardamom/4.jpg';
import hs_16_5 from '../media/homestay/cardamom/5.jpg';
import hs_16_6 from '../media/homestay/cardamom/6.jpg';
import hs_16_7 from '../media/homestay/cardamom/7.jpg';

import hs_17_1 from '../media/homestay/cofeeinn/1.jpg';
import hs_17_2 from '../media/homestay/cofeeinn/2.jpg';
import hs_17_3 from '../media/homestay/cofeeinn/3.jpg';
import hs_17_4 from '../media/homestay/cofeeinn/4.jpg';
import hs_17_5 from '../media/homestay/cofeeinn/5.jpg';
import hs_17_6 from '../media/homestay/cofeeinn/6.jpg';
import hs_17_7 from '../media/homestay/cofeeinn/7.jpg';

import hs_18_1 from '../media/homestay/ghandar/1.jpg';
import hs_18_2 from '../media/homestay/ghandar/2.jpg';
import hs_18_3 from '../media/homestay/ghandar/3.jpg';
import hs_18_4 from '../media/homestay/ghandar/4.jpg';
import hs_18_5 from '../media/homestay/ghandar/5.jpg';
import hs_18_6 from '../media/homestay/ghandar/6.jpg';
import hs_18_7 from '../media/homestay/ghandar/7.jpg';

import hs_19_1 from '../media/homestay/girikarnika/1.png';
import hs_19_2 from '../media/homestay/girikarnika/2.png';
import hs_19_3 from '../media/homestay/girikarnika/3.png';
import hs_19_4 from '../media/homestay/girikarnika/4.png';
import hs_19_5 from '../media/homestay/girikarnika/5.png';

import hs_20_1 from '../media/homestay/girimane/1.png';
import hs_20_2 from '../media/homestay/girimane/2.png';
import hs_20_3 from '../media/homestay/girimane/3.jpg';
import hs_20_4 from '../media/homestay/girimane/4.JPG';
import hs_20_5 from '../media/homestay/girimane/5.JPG';
import hs_20_6 from '../media/homestay/girimane/6.JPG';

import hs_21_1 from '../media/homestay/guddadsiri/1.jpg';
import hs_21_2 from '../media/homestay/guddadsiri/2.jpg';
import hs_21_3 from '../media/homestay/guddadsiri/3.jpg';
import hs_21_4 from '../media/homestay/guddadsiri/1.jpg';
import hs_21_5 from '../media/homestay/guddadsiri/2.jpg';

import hs_22_1 from '../media/homestay/hemakoot/1.jpg';
import hs_22_2 from '../media/homestay/hemakoot/2.jpg';
import hs_22_3 from '../media/homestay/hemakoot/3.jpg';
import hs_22_4 from '../media/homestay/hemakoot/4.jpg';
import hs_22_5 from '../media/homestay/hemakoot/5.jpg';

import hs_23_1 from '../media/homestay/jagte/1.jpg';
import hs_23_2 from '../media/homestay/jagte/2.jpg';
import hs_23_3 from '../media/homestay/jagte/3.jpg';
import hs_23_4 from '../media/homestay/jagte/4.jpg';
import hs_23_5 from '../media/homestay/jagte/5.jpg';
import hs_23_6 from '../media/homestay/jagte/6.jpg';

import hs_24_1 from '../media/homestay/misty/1.jpg';
import hs_24_2 from '../media/homestay/misty/2.jpg';
import hs_24_3 from '../media/homestay/misty/3.jpg';
import hs_24_4 from '../media/homestay/misty/4.jpg';
import hs_24_5 from '../media/homestay/misty/5.jpg';
import hs_24_6 from '../media/homestay/misty/6.jpg';
import hs_24_7 from '../media/homestay/misty/7.jpg';

import hs_25_1 from '../media/homestay/mugilu/1.jpg';
import hs_25_2 from '../media/homestay/mugilu/2.jpg';
import hs_25_3 from '../media/homestay/mugilu/3.jpg';
import hs_25_4 from '../media/homestay/mugilu/4.jpg';
import hs_25_5 from '../media/homestay/mugilu/5.jpg';

import hs_26_1 from '../media/homestay/naturenestate/1.png';
import hs_26_2 from '../media/homestay/naturenestate/2.png';
import hs_26_3 from '../media/homestay/naturenestate/3.png';
import hs_26_4 from '../media/homestay/naturenestate/4.png';
import hs_26_5 from '../media/homestay/naturenestate/5.png';
import hs_26_6 from '../media/homestay/naturenestate/6.png';
import hs_26_7 from '../media/homestay/naturenestate/7.png';
import hs_26_8 from '../media/homestay/naturenestate/8.png';

import hs_27_1 from '../media/homestay/nyritvilla/1.jpg';
import hs_27_2 from '../media/homestay/nyritvilla/2.jpg';
import hs_27_3 from '../media/homestay/nyritvilla/3.jpg';
import hs_27_4 from '../media/homestay/nyritvilla/4.jpg';
import hs_27_5 from '../media/homestay/nyritvilla/5.jpg';

import hs_28_1 from '../media/homestay/oxyzone/1.jpg';
import hs_28_2 from '../media/homestay/oxyzone/2.jpg';
import hs_28_3 from '../media/homestay/oxyzone/3.jpg';
import hs_28_4 from '../media/homestay/oxyzone/4.jpg';
import hs_28_5 from '../media/homestay/oxyzone/5.jpg';
import hs_28_6 from '../media/homestay/oxyzone/6.jpg';
import hs_28_7 from '../media/homestay/oxyzone/7.jpg';
import hs_28_8 from '../media/homestay/oxyzone/8.jpg';
import hs_28_9 from '../media/homestay/oxyzone/9.jpg';



import Devaramane from '../media/homestay/Devaramane.jpg';
import EttinaBhuja from '../media/homestay/EttinaBhuja.jpg';
import Halebidu from '../media/homestay/Halebidu.jpg';
import MagajahalliWaterfalls from '../media/homestay/MagajahalliWaterfalls.jpg';
import PandavaraGudda from '../media/homestay/PandavaraGudda.jpg';
import belur from '../media/Location/belur.jpg';
import bettadabyreweshwaratemple from '../media/Location/bettadabyreweshwaratemple.jpg';
import bisaleghat from '../media/Location/bisaleghat.jpg';
import ettinabuja from '../media/Location/ettinabuja.jpg';
import jenukallupeak from '../media/Location/jenukallupeak.jpg';
import magajahallifalls from '../media/Location/magajahallifalls.jpg';
import manjarabadfort from '../media/Location/manjarabadfort.jpg';

import agniguda from '../media/sakleshpur/sideseen/agniguda.jpg';
import BisleViewPoint from '../media/sakleshpur/sideseen/BisleViewPoint.jpg';
import hadluwaterfall from '../media/sakleshpur/sideseen/hadluwaterfall.jpg';
import hemwatiriver from '../media/sakleshpur/sideseen/hemwatiriver.jpg';
import JenukalGuddaHill from '../media/sakleshpur/sideseen/JenukalGuddaHill.jpg';
import kukkesubramaynaswamitemp from '../media/sakleshpur/sideseen/kukkesubramaynaswamitemp.jpg';
import ManjarabadFort from '../media/sakleshpur/sideseen/ManjarabadFort.jpg';
import ManjehalliWaterfalls from '../media/sakleshpur/sideseen/ManjehalliWaterfalls.jpg';
import OmbattuGuddaHill from '../media/sakleshpur/sideseen/OmbattuGuddaHill.jpg';
import SakaleswaraTemple from '../media/sakleshpur/sideseen/SakaleswaraTemple.jpg';

import coorg_ABBEY_FALLS from '../media/coorg/ABBEY_FALLS.jpg';
import coorg_madikeri_fort from '../media/coorg/madikeri_fort.jpg';
import coorg_mallalli_falls from '../media/coorg/mallalli_falls.jpg';

export const HomeStayA = [
    {
        code: "1",
        name: "PC Homestay",
        location:"Sullakki, Sakleshpur.",
        image: hs_1_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "PC Homestay",
            in_location: "Sullakki, Sakleshpur.",
            in_desc: "Prashantha Chandrama Homestay is located 7kms away from Saklespur town amidst beautiful serene nature. Enroute to Kukke Subramanya and Mangalore, Our Homestay is a den surrounded by mystic beauty of Coffee estates, Paddy fields, Open Mountains, Grass lands, Hemavathi River and Backwaters. One of our country’s best Offroad events takes place in this region. One will wake up with a hot cuppa of Coffee with the melodious sounds of exotic birds and greenery.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_1_1
                },
                {
                    in_img: hs_1_2
                },
                {
                    in_img: hs_1_3
                },
                {
                    in_img: hs_1_4
                },
                {
                    in_img: hs_1_5
                },
                {
                    in_img: hs_1_6
                },
                {
                    in_img: hs_1_7
                },
                {
                    in_img: hs_1_8
                },
            ],
            in_atv: [
                {
                    act: "Enjoy an Offroad drive"
                },
                {
                    act: "Enjoy river water swimming and lazying in it."
                },
                {
                    act: "Catch a fish! Enjoy seasonal fishing"
                },
                {
                    act: "Have a breathtaking offroad drive to a nearby view point where all four district mountains are visible."
                },
                {
                    act: "Trek alongside the green route* on the railway track."
                },
                {
                    act: "Trek from the Homestay to the Munzerabad fort."
                },
                {
                    act: "Take a stroll along side the coffee and pepper plantation."
                },
                {
                    act: "Have a small picnic in the nearby view point."
                },
                {
                    act: "Get yourself wet in the waterfalls."
                },
                {
                    act: "Stretch your muscles for volleyball,throwball,cricket,shuttle badminton games."
                },
                {
                    act: "Bring your brains to work for indoor games such as chess, carom board, Dart etc."
                },
                {
                    act: "Merry around the Camp fire and Music."
                },
                {
                    act: "Become an Ornithologist; watch some exotic birds in this region."
                },
                {
                    act: "Meditation and yoga amidst nature."
                },
                {
                    act: "Reading books with silence and peace."
                },
                {
                    act: "Take time to learn about trees and plants"
                },
                {
                    act: "If you are spiritual, have a visit to the nearby temple."
                },
            ],
            in_visit: [
                {
                    vi_img: SakaleswaraTemple,
                    vi_text: "SAKALESHWARA TEMPLE"
                },
                {
                    vi_img: manjarabadfort,
                    vi_text: "MUNZERABAD FORT"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: jenukallupeak,
                    vi_text: "JENUKALLU GUDDA"
                },
                {
                    vi_img: hemwatiriver,
                    vi_text: "HEMAVATHI RIVER"
                },
                {
                    vi_img: agniguda,
                    vi_text: "AGNI GUDDA"
                },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "GORUR DAM & BACK WATERS"
                // },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "SHETTIHALLI CHURCH"
                // },
                // {
                //     vi_img: belur,
                //     vi_text: "BELUR"
                // },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "HALEBEEDU"
                // },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "MALLALLI FALLS"
                // },
                {
                    vi_img: kukkesubramaynaswamitemp,
                    vi_text: "KUKKE SUBRAMANYA"
                }
            ]
        }
    },
    {
        code: "2",
        name: "Pearl Valley Retreat",
        location:"Kyanahalli, Sakleshpur.",
        image: hs_2_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Pearl Valley Retreat",
            in_location: "Kyanahalli, Sakleshpur.",
            in_desc: "Pearl Valley in Sakleshpur is a premium resort alternative that is a representation of Indian Hospitality at its best. If you are looking for a personalized, experience based holiday or a hectic business travel with a perfect place to relax and be at peace, without compromising on the comforts of a hotel, Pearl Valley Retreat is your answer. Pearl Valley Retreat - A perfect destinations for couples and families seeking a private holiday and that's why we introduce Pearl Valley Retreat in Sakleshpur. If you wish to taste the nature in a luxury atmosphere, reserve your Stay with us.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_2_1
                },
                {
                    in_img: hs_2_2
                },
                {
                    in_img: hs_2_3
                },
                {
                    in_img: hs_2_4
                },
                {
                    in_img: hs_2_5
                },
                {
                    in_img: hs_2_6
                },
                {
                    in_img: hs_2_7
                },
                {
                    in_img: hs_2_8
                },
                {
                    in_img: hs_2_9
                },
            ],
            in_atv: [
                {
                    act: "FOOT BALL"
                },
                {
                    act: "CARROM BOARD"
                },
                {
                    act: "CHESS"
                },
                {
                    act: "ARCHERY"
                },
                {
                    act: "DART GAME"
                },
                {
                    act: "BADMINTON"
                },
                {
                    act: "VOLLEY BALL"
                },
                {
                    act: "BASKET BALL"
                },
                {
                    act: "CRICKET"
                },
            ],
            in_visit: [
                {
                    vi_img: manjarabadfort,
                    vi_text: "MANJARABADH FORT"
                },
                {
                    vi_img: ManjehalliWaterfalls,
                    vi_text: "MOOKANA MANE FALLS"
                },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "PEARL VALLEY FALLS"
                // },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISLE VIEW POINT"
                },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "KADUMANE TEA ESTATE"
                // },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "GREEN ROUTE TREK"
                // },
                // {
                //     vi_img: hs_1_2,
                //     vi_text: "SHETTYHALLI CHURCH"
                // },
            ]
        }
    },
    {
        code: "4",
        name: "Rainbird",
        location:"Hongadahalla, Sakleshpur.",
        image: hs_4_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Rainbird",
            in_location: "Hongadahalla, Sakleshpur.",
            in_desc: "A peaceful Country residence within the land of Sakleshpur located just 12km from the heart of the town. Rainbird Home Stay is an independent bungalow nestled amidst coffee estates of Sakleshpur with a combination of Solitude and luxurious comfort. Experience the warm and homely atmosphere with a blend of comfort and Elegance, pristine with all the amenities making you Stay Enjoyable. Our Homemade food will lure you down to the kitchen to ask our cook for the recipes. Traveling is all about meeting new people, the different experiences that bond people together and that is exactly what we are offering. Rain Bird Home Stay will always be rocking in your mind.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_4_1
                },
                {
                    in_img: hs_4_2
                },
                {
                    in_img: hs_4_3
                },
                {
                    in_img: hs_4_4
                },
                {
                    in_img: hs_4_5
                },
                {
                    in_img: hs_4_6
                },
                {
                    in_img: hs_4_7
                },
                {
                    in_img: hs_4_8
                },
                {
                    in_img: hs_4_9
                },
                {
                    in_img: hs_4_10
                },
            ],
            in_atv: [
                
            ],
            in_visit: [
                {
                    vi_img: SakaleswaraTemple,
                    vi_text: "SAKALESHWARA TEMPLE"
                },
                {
                    vi_img: manjarabadfort,
                    vi_text: "MUNZERABAD FORT"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: jenukallupeak,
                    vi_text: "JENUKALLU GUDDA"
                },
                {
                    vi_img: hemwatiriver,
                    vi_text: "HEMAVATHI RIVER"
                },
                {
                    vi_img: agniguda,
                    vi_text: "AGNI GUDDA"
                },
                {
                    vi_img: kukkesubramaynaswamitemp,
                    vi_text: "KUKKE SUBRAMANYA"
                }
            ]
        }
    },
    {
        code: "5",
        name: "Raxidi Jungle Home",
        location:"Kyamanahalli, Sakleshpur.",
        image: hs_5_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Raxidi Jungle Home",
            in_location: "Kyamanahalli, Sakleshpur.",
            in_desc: "Raxidi Jungle Homes at Sakleshpur is a beautiful escape from the hectic world. Away from the hustle and bustle of the city, this is the perfect place to unwind with your family and friends in the lap of coffee plantations, exotic surroundings, spectacular mountain backdrop, unspoilt wilderness, surging waterfalls, and amazing sunsets. Stroll through the garden and listen to the sound of the birds chirping which will definitely make your evening special. An unmatched hospitality is something you can expect here irrespective of the time of the year you arrive here, alongside with the natural beauty that surrounds this place. The resort is equipped with all the state of art facilities for day to day use. The Camps/Tents are spacious and secured pitched on well-prepared ground.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_5_1
                },
                {
                    in_img: hs_5_2
                },
                {
                    in_img: hs_5_3
                },
                {
                    in_img: hs_5_4
                },
                {
                    in_img: hs_5_5
                },
                {
                    in_img: hs_5_6
                },
                {
                    in_img: hs_5_7
                },
                {
                    in_img: hs_5_8
                },
                {
                    in_img: hs_5_9
                },
            ],
            in_atv: [
                
            ],
            in_visit: [
                {
                    vi_img: SakaleswaraTemple,
                    vi_text: "SAKALESHWARA TEMPLE"
                },
                {
                    vi_img: manjarabadfort,
                    vi_text: "MUNZERABAD FORT"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: jenukallupeak,
                    vi_text: "JENUKALLU GUDDA"
                },
                {
                    vi_img: hemwatiriver,
                    vi_text: "HEMAVATHI RIVER"
                },
                {
                    vi_img: agniguda,
                    vi_text: "AGNI GUDDA"
                },
                {
                    vi_img: kukkesubramaynaswamitemp,
                    vi_text: "KUKKE SUBRAMANYA"
                }
            ]
        }
    },
    {
        code: "7",
        name: "Sankula Homestay",
        location:"Jambaradi, Sakleshpur.",
        image: hs_7_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Sankula Homestay",
            in_location: "Jambaradi, Sakleshpur.",
            in_desc: "Introduction If you are looking for a Sakleshpur stay, Sankula homestay is the best homestay in Sakleshpur. We provide you with all the homely comfort and make your holiday promising and memorable. We have a number of fun family activities and campfire facilities to engage you with some precious time. Our rooms will serve you to the best of the best. We have large and extra large rooms to bring families and friends together. Along with that, we provide rooms with beautiful views, hot water, parking facilities and extra beds. Enjoy our Malnad delicacies during your stay here. Sakleshpur is a beautiful place for outing and vacation and we make this even more special to you with our homely atmosphere and utmost care.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_7_1
                },
                {
                    in_img: hs_7_2
                },
                {
                    in_img: hs_7_3
                },
                {
                    in_img: hs_7_4
                },
                {
                    in_img: hs_7_5
                },
                {
                    in_img: hs_7_6
                },
                {
                    in_img: hs_7_7
                },
                {
                    in_img: hs_7_8
                }
            ],
            in_atv: [
                {
                    act: "Fire Campp"
                },
                {
                    act: "Family Fun"
                },
                {
                    act: "Trekking"
                },
                {
                    act: "River Fun"
                },
                {
                    act: "Bird Watching"
                },
                {
                    act: "Indoor Games"
                },
                {
                    act: "Mud volleyball"
                },
                {
                    act: "Rain dance"
                },
                {
                    act: "Zip-line"
                },
                {
                    act: "Burma bridgee"
                },
            ],
            in_visit: [
                {
                    vi_img: SakaleswaraTemple,
                    vi_text: "SAKALESHWARA TEMPLE"
                },
                {
                    vi_img: manjarabadfort,
                    vi_text: "MUNZERABAD FORT"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: jenukallupeak,
                    vi_text: "JENUKALLU GUDDA"
                },
                {
                    vi_img: hemwatiriver,
                    vi_text: "HEMAVATHI RIVER"
                },
                {
                    vi_img: agniguda,
                    vi_text: "AGNI GUDDA"
                },
                {
                    vi_img: kukkesubramaynaswamitemp,
                    vi_text: "KUKKE SUBRAMANYA"
                }
            ]
        }
    },
    {
        code: "8",
        name: "SimplyCamp",
        location:"Donahalli, Sakleshpur.",
        image: hs_8_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "SimplyCamp",
            in_location: "Donahalli, Sakleshpur.",
            in_desc: "As our name suggests we are a simple camping place amidst bounty full nature. We can accommodate up 21 people and we provide camping place only to ONE group, be it 2 people or a group of 20. That way we provide you a luxurious weekend stay with exclusivity. We got all equipment for camping and make sure you are feasted with clean, home cooked, locally sourced food. There are 3 cleanly maintained washrooms, exclusively built for camping. Apart from that, we are located 1 KM away from a water fall, got trekking spots, rope games, mud volley ball, badminton court, fire camp place and barbecue arrangements can be accommodated upon request. The property is fully safe and secured for the family groups. The owner's family stays next to the camping site and will be at a shouting distance from the guests round the clock. If you are an avid Biker, SimplyCamp is THE Destination for you. Get relaxed in our camps after a long bike ride and we assure, you will forget the fatigue you developed while riding.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_8_1
                },
                {
                    in_img: hs_8_2
                },
                {
                    in_img: hs_8_3
                },
                {
                    in_img: hs_8_4
                },
                {
                    in_img: hs_8_5
                },
                {
                    in_img: hs_8_6
                }
            ],
            in_atv: [
                {
                    act: "CAMP FIRE"
                },
                {
                    act: "TREKKING SPOTS"
                },
                {
                    act: "TEAM ACTIVITIES"
                },
                {
                    act: "LAGORI"
                },
                {
                    act: "BADMINTON"
                },
                {
                    act: "KABADDI"
                },
                {
                    act: "WOODS WALK"
                },
                {
                    act: "MUD VOLLEYBALL"
                }
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: Halebidu,
                    vi_text: "HALEBIDU"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: Devaramane,
                    vi_text: "DEVARAMANE"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                },
                {
                    vi_img: EttinaBhuja,
                    vi_text: "ETTINA BHUJA"
                },
                {
                    vi_img: PandavaraGudda,
                    vi_text: "PANDAVARA GUDDA"
                }
            ]
        }
    },
    {
        code: "8",
        name: "Swastha HomeStay",
        location:"Byakaravalli, Sakleshpur.",
        image: hs_9_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Swastha HomeStay",
            in_location: "Byakaravalli, Sakleshpur.",
            in_desc: "Now it is your turn to come and enjoy. Get a slice of real malnad (Sakleshpur).     With just 4 to 5 hours of travel by road from Bangalore via Hassan, it is easy to plan your holiday. We welcome all those who love nature. It is an ideal place for solitude away from noise and pollution of the city life. Our emphasis is on exclusivity. Since we just have one villa you will have all the privacy you need with just you, your family and friends. The Sakleshpur surrounding areas in and around ‘swastha homestay’ is richly endowed by nature with beautiful meadows, rivers, hills, estates there are lots of unspoilt places to visit and best part is that most of them are off the beaten track. Another highlight of Swastha homestay is the local cuisine there are different cuisine during each seasons along with all time favorites, all locally sourced and we promote eco friendly farming practices. We have been approved by dept of tourism. Swastha means good health and we constantly strive to promote it in our eco friendly homestay.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_9_1
                },
                {
                    in_img: hs_9_2
                },
                {
                    in_img: hs_9_3
                },
                {
                    in_img: hs_9_4
                },
                {
                    in_img: hs_9_5
                }
            ],
            in_atv: [
                {
                    act: "Trekking"
                },
                {
                    act: "Estate walk"
                },
                {
                    act: "Shooting Spots"
                }
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                }
            ]
        }
    },
    {
        code: "10",
        name: "Tusker Valley",
        location:"Attihalli, Sakleshpur.",
        image: hs_10_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Tusker Valley",
            in_location: "Attihalli, Sakleshpur.",
            in_desc: "Tusker Valley is one of the best riverside homestays in sakleshpur where the radiant beams of the sun kiss the beautiful greenery and bounce off of natural water bodies all around, with a history of its own and an approach for the future. We are a homestay dedicated to making our guests' holiday memorable in every way starting from the property that greets you, to your own cosy riverfront cottage or adventure tent and the rush of our adventure sports. Swing by the ropes or zip-line across the water at one of the best Sakleshpur resorts and homestays. We maintain the highest standards with our service and safety measures so that every time you want to make a Sakleshpur trip, Tusker Valley is your number 1 choice! The main feature of these homestays in sakleshpur for family is the beautiful nature around which has an amazing Nearby attraction that includes Viewing point, Mookana Mane Habbi Waterfalls, Kaginahare Fort, Manjarabad Fort etc. which are historically relevant and naturally enticing as well! Tusker Valley is one of the homestays in sakleshpur with swimming pool for a premium experience for families, corporates and all travellers. Sakleshpur is calling all birders, nature lovers and adventurers!",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_10_1
                },
                {
                    in_img: hs_10_2
                },
                {
                    in_img: hs_10_3
                },
                {
                    in_img: hs_10_4
                },
                {
                    in_img: hs_10_5
                },
                {
                    in_img: hs_10_6
                }
            ],
            in_atv: [
                {
                    act: "BONFIRE WITH MUSIC"
                },
                {
                    act: "SWIMMING IN RIVER WITH LIFE JACKETS"
                },
                {
                    act: "INDOOR GAMES – CHESS & CARROM"
                },
                {
                    act: "OUT DOOR GAMES"
                },
                {
                    act: "ZIP LINE(FLYING FOX)"
                },
                {
                    act: "KAYAKING"
                },
                {
                    act: "TEAM BUILDING AND FUN GAMES"
                },
                {
                    act: "ARCHERY"
                },
                {
                    act: "RAIN DANCE WITH MUSIC"
                },
                {
                    act: "ROPE CHALLENGE - JUMARING & RIVER CROSSING"
                },
                {
                    act: "4 X 4 JEEP OFF-ROAD"
                },
                {
                    act: "ARCHERY"
                },
                {
                    act: "ARCHERY"
                }
            ],
            in_visit: [                
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                }
            ]
        }
    },
    {
        code: "11",
        name: "Veeras Western",
        location:"Cowdhalli, Sakleshpur.",
        image: hs_11_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Veeras Western",
            in_location: "Cowdhalli, Sakleshpur.",
            in_desc: "Now the ball is in your court to come and appreciate. Get a cut of genuine malnad (Sakleshpur). With only 4 to 5 long stretches of movement by street from Bangalore by means of Hassan, it is anything but difficult to design your vacation. We respect every one of the individuals who love nature. It is a perfect place for isolation far from clamor and contamination of the city life. Our accentuation is on selectiveness. Since we simply have one estate you will have all the protection you require with just you, your family and companions. The Sakleshpur encompassing territories in and around 'Veeras Wester' is luxuriously blessed by nature with wonderful knolls, waterways, slopes, homes there are heaps of untainted spots to visit and best part is that a large portion of them are off the beaten track. Another feature of Veeras Wester is the nearby food there are diverse cooking amid every season alongside unequaled top choices, all privately sourced and we advance eco inviting cultivating hones. We have been endorsed by dept of tourism. Veeras Wester implies great wellbeing and we always endeavor to advance it in our eco amicable homestay. ow the ball is in your court to come and appreciate. Get a cut of genuine malnad (Sakleshpur). With only 4 to 5 long stretches of movement by street from Bangalore through Hassan, it is anything but difficult to design your vacation. We respect every one of the individuals who love nature. It is a perfect place for isolation far from clamor and contamination of the city life. Our accentuation is on eliteness. Since we simply have one estate you will have all the protection you require with just you, your family and companions. The Sakleshpur encompassing zones in and around 'swastha homestay' is luxuriously enriched by nature with excellent glades, streams, slopes, bequests there are heaps of pristine spots to visit and best part is that the majority of them are off the beaten track. Another feature of Swastha homestay is the neighborhood cooking there are distinctive food amid every season alongside untouched top picks, all privately sourced and we advance eco agreeable cultivating rehearses. We have been affirmed by dept of tourism. Swastha implies great wellbeing and we continually endeavor to advance it in our eco agreeable homestay.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_11_1
                },
                {
                    in_img: hs_11_2
                },
                {
                    in_img: hs_11_3
                },
                {
                    in_img: hs_11_4
                },
                {
                    in_img: hs_11_5
                }
            ],
            in_atv: [
                {
                    act: "TrekkingE"
                },
                {
                    act: "Estate Walking"
                },
                {
                    act: "Shooting Spot"
                },
                {
                    act: "Camp Fire"
                }
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                }
            ]
        }
    },
    {
        code: "12",
        name: "Atavi Homestay",
        location:"Hongadahalli, Sakleshpur.",
        image: hs_12_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Atavi Homestay",
            in_location: "Hongadahalli, Sakleshpur.",
            in_desc: "he homestay is located in a beautiful stream bed in the midst of the Western Ghats. Atavi means forest. The name of the place is Doddagaddhe Horatti which is named after a large paddy field known as Doddagaddhe in the backyard of the Homestay.This valley is surrounded by vast wooded mountains, grasslands and great flora and fauna with rare species of birds, animals and other natural wildlife habitats. Western Ghats are known for its rich biodiversity and are one amongst worlds 18 mega biodiversity hotspots.The environment keeps the region cool and pleasant. It is a great travel destination.The homestay started with the intention of creating awareness among people about conservation of “The Western Ghats”. Away from the densely populated, heavily polluted cities tourists can rejuvenate themselves with silence,sounds of nature, fresh air & water a totally different environment.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_12_1
                },
                {
                    in_img: hs_12_2
                },
                {
                    in_img: hs_12_3
                },
                {
                    in_img: hs_12_4
                },
                {
                    in_img: hs_12_5
                }
            ],
            in_atv: [
                {
                    act: "Go Hiking in The Western Ghats"
                },
                {
                    act: "Enjoy Swimming"
                },
                {
                    act: "Fire Camp gives true Wilderness feeling"
                },
                {
                    act: "Volley Ball"
                },
                {
                    act: "Shuttle Cock"
                },
                {
                    act: "Carrom"
                },
                {
                    act: "Chess"
                },
                {
                    act: "Water Volley Ball"
                }
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                }
            ]
        }
    },
    {
        code: "13",
        name: "Bann Nimbus",
        location:"Arekere, Sakleshpur.",
        image: hs_13_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Bann Nimbus",
            in_location: "Arekere, Sakleshpur.",
            in_desc: "It is around a village square where blooming Frangipani, Bougainvilleas, ferns cast soft shadows. This court is defined by the Jaili or verandahs which feature carefully arranged thick wooden furniture and earthy surfaces. This place would have been impossible without the local workman and support. The quaint and the lazy verandah overlooks swimming pool which reflects the sky.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_13_1
                },
                {
                    in_img: hs_13_2
                },
                {
                    in_img: hs_13_3
                },
                {
                    in_img: hs_13_4
                },
                {
                    in_img: hs_13_5
                },
                {
                    in_img: hs_13_6
                }
            ],
            in_atv: [
                {
                    act: "Go Hiking in The Western Ghats"
                },
                {
                    act: "Enjoy Swimming"
                },
                {
                    act: "Fire Camp gives true Wilderness feeling"
                }
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                }
            ]
        }
    },
    {
        code: "14",
        name: "Bidirinakadu Homestay",
        location:"Hurudi, Sakleshpur.",
        image: hs_14_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Bidirinakadu Homestay",
            in_location: "Hurudi, Sakleshpur.",
            in_desc: "BIDIRINA KADU is a plantation stay, an elegant home built in traditional Malnad style .It is an ideal place for solitude away from noise and pollution of the city life. We will help you to feel the Malnad culture, cuisine and lifestyle in a warm traditional environment. A Stay where you can simply retreat from the turmoil of everyday life and discover the peace of nature. We are committed to providing genuine service, Malnad cuisine as well as a variety of activities using sustainable method to create a quality experience for our guests in a natural environment .The Coffee Estate, birdlife ,lake view, swimming and surrounding grasslands of this home provides a feast for the senses- an inspiring setting amidst flowers, variety of plants and trees, and healing water offers you peace and tranquility. Another highlight of BIDIRINA KADU homestay is the local cuisine there are different cuisine during each seasons along with all time favorites, all locally sourced and we promote eco friendly farming practices. We have been approved by department of tourism.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_14_1
                },
                {
                    in_img: hs_14_2
                },
                {
                    in_img: hs_14_3
                },
                {
                    in_img: hs_14_4
                },
                {
                    in_img: hs_14_5
                },
                {
                    in_img: hs_14_6
                }
            ],
            in_atv: [
                {
                    act: "Camp fire"
                },
                {
                    act: "Plantation walk"
                },
                {
                    act: "Trekking"
                },
                {
                    act: "Waterfalls"
                }
            ],
            in_visit: [                
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                }
            ]
        }
    },
    {
        code: "15",
        name: "Brindhavan Homestay",
        location:"Arekere, Sakleshpur.",
        image: hs_15_3,
        facility: "24 hrs hot water, Toiletries, RO drinking water, 1.65 kva UPS for uninterrupted power supply",
        details: {
            in_name: "Brindhavan Homestay",
            in_location: "Arekere, Sakleshpur.",
            in_desc: "Brindhavan homestay is located in 22 acres of coffee plantation, surrounded by coffee, cardamom, pepper and areca plantations, accommodation is clean and cozy, we have four spacious rooms with attached sit out and bathrooms, each room can accommodate 5 adults comfortably, Separate dining and kitchen area, also a hut for campfire beautifully done with lake view. Experience relaxed stay amidst greenery breathing fresh air peacefully away from hustle and bustle of city. We are located about 235 kms from Bengaluru and 126 kms from Mangaluru, accessible by roads in all seasons.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_15_1
                },
                {
                    in_img: hs_15_2
                },
                {
                    in_img: hs_15_3
                },
                {
                    in_img: hs_15_4
                },
                {
                    in_img: hs_15_5
                },
                {
                    in_img: hs_15_6
                },
                {
                    in_img: hs_15_7
                },
                {
                    in_img: hs_15_8
                }
            ],
            in_atv: [
                {
                    act: "Mud pool by the lake next to 22 ft shower."
                },
                {
                    act: "Beat the heat under 22 ft high shower in the plantation, natural water flow diverted through shower."
                },
                {
                    act: "Bird watching with zoom camera, more than 80 species of birds spotted in our plantation."
                },
                {
                    act: "Indoor and outdoor sports equipments like carom, chess, football, badminton, cricket etc."
                },
                {
                    act: "Guided plantation walk."
                },
                {
                    act: "Short trek along beautiful meadows."
                },
                {
                    act: "Camp in the scenic meadows."
                },
                {
                    act: "Barbecue along campfire."
                },
                {
                    act: "Campfire"
                }
            ],
            in_visit: [                
                {
                    vi_img: BisleViewPoint,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "Malalli water falls"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur"
                }
            ]
        }
    },
    {
        code: "16",
        name: "Cardamom Grove Homestay",
        location:"Atthihalli, Sakleshpur.",
        image: hs_16_3,
        facility: "24 hrs hot water, Toiletries, RO drinking water, 1.65 kva UPS for uninterrupted power supply",
        details: {
            in_name: "Cardamom Grove Homestay",
            in_location: "Atthihalli, Sakleshpur.",
            in_desc: "Cardamom Grove Homestay is located 3 km from the majestic Mookanmane Water Falls. Tucked amidst lush green coffee plantations, Cardamom Grove is centrally located in the Coorg-Hassan border town of Sakleshpur. With close proximity to most Coorg tourist attractions, Cardamom Grove is ideally suited for families and a relaxing weekend with friends. Far from the maddening crowd and surrounded by vibrant green coffee, pepper and cardamom plants amidst a variety of tropical trees, Cardamom Grove homestay is located in the Western Ghats. With the green so lush, it awakens the poet in you and interiors that rejuvenates; Cardamom Grove offers a mesmerizing view of Sahyadri ranges and picturesque morning mist clouds.  Monsoon at Cardamom Grove homestay can be sheer magic with scenic rains and the smell of freshly brewed coffee and authentically made food to go along. This homestay is an exquisite hideaway and a naturalist’s treasure trove, making Cardamom Grove homestay the best homestay in the region. Explore the must-visit places near Sakleshpur during your rejuvenating holiday at one of the best homestays in the region of Sakleshpur.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_16_1
                },
                {
                    in_img: hs_16_2
                },
                {
                    in_img: hs_16_3
                },
                {
                    in_img: hs_16_4
                },
                {
                    in_img: hs_16_5
                },
                {
                    in_img: hs_16_6
                },
                {
                    in_img: hs_16_7
                }
            ],
            in_atv: [                
                {
                    act: "Campfire"
                }
            ],
            in_visit: [                
                {
                    vi_img: BisleViewPoint,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur"
                }
            ]
        }
    },
    {
        code: "17",
        name: "Coffee Inn",
        location:"Hanbal, Sakleshpur.",
        image: hs_17_3,
        facility: "Parking, Pets Allowed, External Fireplace, Playground & Activities, Malnad Food, Free Coffee",
        details: {
            in_name: "Coffee Inn",
            in_location: "Hanbal, Sakleshpur.",
            in_desc: "Situated in the midst of greenery CoffeeInn is a traditional restored home with a pleasant view of coffee plantation. We pride ourselves being perfect for discerning travelers seeking a special place to be welcomed and to feel at home. We welcome you to enjoy the generosity of true hospitality. We are 3700 feet above the sea level and in the heart of lush green landscape of 25 acres with plantations of coffee, pepper and rubber. We welcome you with family & friends for experiencing nice hospitality. Treat your taste buds with great food and relax by aligning yourself with nature. ",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_17_1
                },
                {
                    in_img: hs_17_2
                },
                {
                    in_img: hs_17_3
                },
                {
                    in_img: hs_17_4
                },
                {
                    in_img: hs_17_5
                },
                {
                    in_img: hs_17_6
                },
                {
                    in_img: hs_17_7
                }
            ],
            in_atv: [                
                {
                    act: "Lake Boating"
                },             
                {
                    act: "Outdoor Play Area"
                },             
                {
                    act: "Zipline"
                },             
                {
                    act: "Pond"
                },             
                {
                    act: "River Visit"
                },             
                {
                    act: "Estate Walk"
                }
            ],
            in_visit: [                
                {
                    vi_img: coorg_ABBEY_FALLS,
                    vi_text: "Abbi Falls"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur"
                }
            ]
        }
    },
    {
        code: "18",
        name: "Ghandar Cool Homestay",
        location:"Agani, Sakleshpur.",
        image: hs_18_3,
        facility: "King size Beds, Designer Bathroom, Full Balcony View, Hot Water Supply",
        details: {
            in_name: "Ghandar Cool Homestay",
            in_location: "Agani, Sakleshpur.",
            in_desc: "Karnataka, a land with around 60% of the Western Ghats, has been blessed with some of the most exotic spots and tourist destinations. One such panoramic location, tucked in a remote corner of Sakleshpur district is Ghandhar Cool. Ghandhar Cool is the name of the mountain and it is known to be the place of the Ghandarvas. A six hour drive from Bangalore with well connected roads, can get you to Ghandhar Cool. This place is a perfect getaway from all the hustles and bustles of a routine city life. With numerous waterfalls, trekking trails, campsites, picturesque coffee estates, calm and serene sunset spots and an abundance of beauty in Mother Nature’s lap, this is a perfect tourist destination for serene leisure and comfort. Ghandhar Cool attracts people of all age groups, including those who like trekking adventures. We provide comfortable accommodation and authentic Malnad cuisine, which vegetarian and non-vegetarian diets, to ensure a pleasurable visit to Ghadhar Cool. Come to Ghandar Cool for a lifetime experience of being one with 'Mother Nature'. Enjoy every bit of Gandhar Cool, from peaks to valleys, from rivers to falls and from grasslands to thick forests, rich coffee estates and much more. Leave the rest to us! We will make your stay worthwhile and memorable with our comfortable accommodation, delicious Malnad cuisine, priceless guidance and benevolent hospitality. ",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_18_1
                },
                {
                    in_img: hs_18_2
                },
                {
                    in_img: hs_18_3
                },
                {
                    in_img: hs_18_4
                },
                {
                    in_img: hs_18_5
                },
                {
                    in_img: hs_18_6
                },
                {
                    in_img: hs_18_7
                }
            ],
            in_atv: [                
                {
                    act: "Volleyball"
                },             
                {
                    act: "Football"
                },             
                {
                    act: "Shuttle"
                },             
                {
                    act: "Slush Volleyball"
                },             
                {
                    act: "Cricket"
                },             
                {
                    act: "Camp Fire"
                },             
                {
                    act: "Jungle Trekking"
                },             
                {
                    act: "Plantation Tours"
                },             
                {
                    act: "Jeep drive"
                }
            ],
            in_visit: [                
                {
                    vi_img: coorg_ABBEY_FALLS,
                    vi_text: "Abbi Falls"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur"
                }
            ]
        }
    },
    {
        code: "19",
        name: "Girikarnika Homestay",
        location:"Palahalli, Sakleshpur.",
        image: hs_19_3,
        facility: "Fresh Productss, Healthy Food, Traditional Methods, Advance Booking",
        details: {
            in_name: "Girikarnika Homestay",
            in_location: "Palahalli, Sakleshpur.",
            in_desc: "Girikarnika Homestay at Palahalli,Uchangi in Sakaleshpur Taluk in Hassan District of Karnataka State, India., offers well furnished, spacious rooms with a pleasant and homely decor to make your stay relaxed & enjoyable. Added to this, our Facilities and Services are so carefully chosen as to provide maximum comfort and memorable experience for our valued guests to ensure spending a quality time when you are on business or pleasure tour with your family.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_19_1
                },
                {
                    in_img: hs_19_2
                },
                {
                    in_img: hs_19_3
                },
                {
                    in_img: hs_19_4
                },
                {
                    in_img: hs_19_5
                }
            ],
            in_atv: [                
                {
                    act: "Camp Fire"
                }
            ],
            in_visit: [                
                {
                    vi_img: coorg_ABBEY_FALLS,
                    vi_text: "Abbi Falls"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur"
                }
            ]
        }
    },
    {
        code: "20",
        name: "Girimane Homestay",
        location:"Vanagur, Sakleshpur.",
        image: hs_20_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Girimane Homestay",
            in_location: "Vanagur, Sakleshpur.",
            in_desc: "We are exactly 20km from Sagar, surrounded by green forests and areca nut plantations. There are many tourist places around Sagar where you can spend a day.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_20_1
                },
                {
                    in_img: hs_20_2
                },
                {
                    in_img: hs_20_3
                },
                {
                    in_img: hs_20_4
                },
                {
                    in_img: hs_20_5
                },
                {
                    in_img: hs_20_6
                }
            ],
            in_atv: [
                {
                    act: "CAMP FIRE"
                }
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: Halebidu,
                    vi_text: "HALEBIDU"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: Devaramane,
                    vi_text: "DEVARAMANE"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                },
                {
                    vi_img: EttinaBhuja,
                    vi_text: "ETTINA BHUJA"
                },
                {
                    vi_img: PandavaraGudda,
                    vi_text: "PANDAVARA GUDDA"
                }
            ]
        }
    },
    {
        code: "21",
        name: "Guddada Siri Homestay",
        location:"Doneahalli, Sakleshpur.",
        image: hs_21_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Guddada Siri Homestay",
            in_location: "Doneahalli, Sakleshpur.",
            in_desc: "Guddada siri homestay is located at Devaladakere near hanabal in Sakleshpura taluka, Hassan District. Surrounded by the medows of western ghats, Gives you a advantages to get near to the nature. The beautiful forest refreshes your mind and nourishes your Life. We provide the best services to make your holiday, a best holiday ever. Come enjoy, give us a chance to serve you.Guddada Siri...",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_21_1
                },
                {
                    in_img: hs_21_2
                },
                {
                    in_img: hs_21_3
                },
                {
                    in_img: hs_21_4
                },
                {
                    in_img: hs_21_5
                }
            ],
            in_atv: [
                {
                    act: "Water Splash"
                },
                {
                    act: "Mud Volley Ball"
                },
                {
                    act: "Archery"
                },
                {
                    act: "Rope Cycling"
                },
                {
                    act: "2 Seater Boating"
                },
                {
                    act: "Single Pole Basket ball"
                },
                {
                    act: "Batmintion"
                },
                {
                    act: "Mini Cricket"
                },
                {
                    act: "Carrom"
                },
                {
                    act: "Treking (Extra Chargable)"
                },
                {
                    act: "Fire Camp"
                },
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: Halebidu,
                    vi_text: "HALEBIDU"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: Devaramane,
                    vi_text: "DEVARAMANE"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                },
                {
                    vi_img: EttinaBhuja,
                    vi_text: "ETTINA BHUJA"
                },
                {
                    vi_img: PandavaraGudda,
                    vi_text: "PANDAVARA GUDDA"
                }
            ]
        }
    },
    {
        code: "22",
        name: "HemaKoota Homestay",
        location:"Atthihalli, Sakleshpur.",
        image: hs_22_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "HemaKoota Homestay",
            in_location: "Atthihalli, Sakleshpur.",
            in_desc: "'HemaKoota,' in Kannada translates to 'golden gathering.' is established in Atthihally near Sakleshpur. Built with Malnad architectural blend, Five-bedroom property with spacious verandah and attached bathrooms are open to guests from 2015. It is surrounded by coffee/cardamom and pepper plantations on one side and few homes, on the other side, providing the perfect essence of country life. The property is owned and managed by us, Gowtham and Manu Gowtham. We live in a century-old house next to the property. We are involved in farming for the past 30 years and in the hospitality business for over ten years. We believe consistency is the key to success, and we take pride in being ranked #1 in specialty lodging on TripAdvisor and also on google from 2016, which comes down to impeccable hospitality and exceptional service. We shall not forget to mention the showstopper 'Kiwi' - one of the coolest pooches!",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_22_1
                },
                {
                    in_img: hs_22_2
                },
                {
                    in_img: hs_22_3
                },
                {
                    in_img: hs_22_4
                },
                {
                    in_img: hs_22_5
                }
            ],
            in_atv: [
                {
                    act: "Fire Camp"
                },
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: Halebidu,
                    vi_text: "HALEBIDU"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: Devaramane,
                    vi_text: "DEVARAMANE"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: MagajahalliWaterfalls,
                    vi_text: "MAGAJANAHALLI WATERFALLS"
                },
                {
                    vi_img: EttinaBhuja,
                    vi_text: "ETTINA BHUJA"
                },
                {
                    vi_img: PandavaraGudda,
                    vi_text: "PANDAVARA GUDDA"
                }
            ]
        }
    },
    {
        code: "23",
        name: "Jagate’s Mist",
        location:"Vanagur, Sakleshpur.",
        image: hs_23_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Jagate’s Mist",
            in_location: "Vanagur, Sakleshpur.",
            in_desc: "Jagate’s Mist is an picturesque Homestay in sakleshpur – away from your Home in middle of nature. This friendly, idiosyncratic homestay in sakleshpur is around 230 km from Bangalore(4 hours 30 min Drive), located in a small hamlet called Vanagoor in the foothills of western ghats. This villa is amidst 20 acres of Coffee and Cardamom plantation with a vast stretch of greenery. You can witness beautiful plantation, unspoiled forest and a green hilly landscapes surrounding this homestay. The snow white mist which covers the homestay in the morning, adds a misty flavor to the beauty of this place. The Village has a vast amount of walking/hiking trails, streams, and scenic roads which makes this homestay an unique place in Sakleshpur. This Homestay is a comfortable and spacious villa to spend your holiday with your family and friends. This house has three well furnished bed rooms. All bed rooms have attached bathrooms with state of the art fittings. We value you as our guest and recognize that privacy is utmost important to you, and hence the entire villa is dedicated to the guests; you will get all the peaceful privacy you need with your family and friends. Delicious Malnad food made tasty with the warmth of perfect hospitality awaits you to relish, rejuvenate and return with the memory of a most unique holiday in an ideal homestay in sakleshpur.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_23_1
                },
                {
                    in_img: hs_23_2
                },
                {
                    in_img: hs_23_3
                },
                {
                    in_img: hs_23_4
                },
                {
                    in_img: hs_23_5
                },
                {
                    in_img: hs_23_6
                }
            ],
            in_atv: [
                {
                    act: "Bonfire"
                },
                {
                    act: "Rope Activity"
                },
            ],
            in_visit: [
                {
                    vi_img: belur,
                    vi_text: "BELUR"
                },
                {
                    vi_img: coorg_ABBEY_FALLS,
                    vi_text: "MOOKANAMANE ABBI WATERFALL"
                },
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: coorg_mallalli_falls,
                    vi_text: "MALLALLI WATERFALLS"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                }
            ]
        }
    },
    {
        code: "24",
        name: "Misty Mountains Homestay",
        location:"Haragarahalli, Sakleshpur.",
        image: hs_24_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Misty Mountains Homestay",
            in_location: "Haragarahalli, Sakleshpur.",
            in_desc: "Come holidays most of us are on a lookout for serene retreat that would take us well away from the pollution of the city. A place which will give you the quality time, precious moments with family & friends, A place which takes you close to nature, A place which give you utmost peace & solace. If you are looking any one of these, then your destination must be our homestay in Sakleshpur “ Misty Mountains ”. Misty Mountains offers the perfect getaway for your holidays, short break or group outings. Sakleshpura is a serene hill station town situated 240 Kms from Bangalore. Surrounded by coffee, pepper and cardamom plantations this Sakleshpur is known as a region that receives the maximum rainfall from the Southwest monsoon in Karnataka. A short journey for 4 hours from Bengaluru to Sakleshpur will take you our Homestay which is surrounded by Western Ghats mountains covered by Mist most of the year. This gives name of our homestay in Sakleshpur naturally as “ MISTY MOUNTAINS ”.Our Homestay in Sakleshpur offers you many things, Peace and quiet ambience to recuperate from the rigours of city life, nature’s bounty, scenic views, picturesque habitats and a glimpse at a quaint life. Our guest house in Sakleshpur is a exclusive villa which is designed on the lines of nature. Our villa has four deluxe rooms along with common dining room and a comfortable lounge to enjoy the crisp morning air while we serve you coffee with cookies! We serve delectable malnad delicacies and would take you on a gastronomic journey of this region during your stay. All the guest rooms are built to provide you with a great view of the Misty Mountains and the plantations. Rejuvenate yourself in this hilly retreat and have one of the best time of your life. Come visit us for your Date with nature…………..",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_24_1
                },
                {
                    in_img: hs_24_2
                },
                {
                    in_img: hs_24_3
                },
                {
                    in_img: hs_24_4
                },
                {
                    in_img: hs_24_5
                },
                {
                    in_img: hs_24_6
                },
                {
                    in_img: hs_24_7
                }
            ],
            in_atv: [
                {
                    act: "Bonfire"
                }
            ],
            in_visit: [
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                }
            ]
        }
    },
    {
        code: "25",
        name: "Mugilu",
        location:"Bugudahalli, Sakleshpur.",
        image: hs_25_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Mugilu",
            in_location: "Bugudahalli, Sakleshpur.",
            in_desc: "Our homestay cottages in Sakleshpur are built with love, and above all, by those who love to travel. Individual cottages for small families and a larger “family room” for family groups. Undoubtedly, you’ll love them – simple, homely, private and peaceful.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_25_1
                },
                {
                    in_img: hs_25_2
                },
                {
                    in_img: hs_25_3
                },
                {
                    in_img: hs_25_4
                },
                {
                    in_img: hs_25_5
                }
            ],
            in_atv: [
                {
                    act: "Bonfire"
                }
            ],
            in_visit: [
                {
                    vi_img: bisaleghat,
                    vi_text: "BISILE VIEW POINT"
                },
                {
                    vi_img: ManjarabadFort,
                    vi_text: "MANJRABAD FORT"
                },
                {
                    vi_img: coorg_mallalli_falls,
                    vi_text: "Mallalli Falls"
                }
            ]
        }
    },
    {
        code: "26",
        name: "Nature Homestay",
        location:"Honkaravalli, Sakleshpur.",
        image: hs_26_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Nature Homestay",
            in_location: "Honkaravalli, Sakleshpur.",
            in_desc: "Our homestay cottages in Sakleshpur are built with love, and above all, by those who love to travel. Individual cottages for small families and a larger “family room” for family groups. Undoubtedly, you’ll love them – simple, homely, private and peaceful.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_26_1
                },
                {
                    in_img: hs_26_2
                },
                {
                    in_img: hs_26_3
                },
                {
                    in_img: hs_26_4
                },
                {
                    in_img: hs_26_5
                },
                {
                    in_img: hs_26_6
                },
                {
                    in_img: hs_26_7
                },
                {
                    in_img: hs_26_8
                }
            ],
            in_atv: [
                {
                    act: "Plantation Walk"
                },
                {
                    act: "Lake With Hanging Bridge"
                },
                {
                    act: "Bird Watching Tower"
                },
                {
                    act: "Cycling"
                },
                {
                    act: "Carrom Board"
                },
                {
                    act: "Volley Ball"
                },
                {
                    act: "Net Climbing"
                },
                {
                    act: "Rain Dance With Mini Pool"
                },
                {
                    act: "Mud Volley Ball"
                },
                {
                    act: "Table Tennis"
                },
                {
                    act: "Night Camp Fire With Music"
                },
                {
                    act: "Basket Ball"
                },
                {
                    act: "Foose Ball"
                },
                {
                    act: "Badminton"
                },
                {
                    act: "Air Pistol"
                },
                {
                    act: "Bow Xarrow"
                },
                {
                    act: "Chess"
                },
                {
                    act: "Traditional Games"
                },
                {
                    act: "Cricket with Net(Group)"
                },
                {
                    act: "Playing Cards"
                },
                {
                    act: "Skating"
                },
                {
                    act: "Segway Ride"
                },
                {
                    act: "Hover Board"
                }
            ],
            in_visit: [
                {
                    vi_img: manjarabadfort,
                    vi_text: "Manjarabad Fort"
                },
                {
                    vi_img: agniguda,
                    vi_text: "Agni Gudda Hill"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur / Halebidu"
                },
                {
                    vi_img: BisleViewPoint,
                    vi_text: "Bisle Ghat"
                }
            ]
        }
    },
    {
        code: "27",
        name: "Nyritvilla Homestay",
        location:"Halasulige, Sakleshpur.",
        image: hs_27_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Nyritvilla Homestay",
            in_location: "Halasulige, Sakleshpur.",
            in_desc: "Sakaleshpura is a malnad district in the Western ghats in south-western Karnataka and is blessed with an abundance of Nature's bounties. Misty hills, meandering streams, thick tropical jungles and verdant coffee estates make this inexpressibly beautiful land one of the bio-diversity hotspots in the entire world. The variety of flora and fauna, make it a nature lover's Paradise. At Nyritvilla Homestay, wake up to the songs and chatter of birds. While away your time amidst nature, sipping endless cups of home-grown coffee, indulge yourself in sinfully tasty food and let your body and mind relax and recuperate from the stress of city life. The only sounds you hear are the songs of the birds, the whisper of the wind and the gurgle of the stream.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_27_1
                },
                {
                    in_img: hs_27_2
                },
                {
                    in_img: hs_27_3
                },
                {
                    in_img: hs_27_4
                },
                {
                    in_img: hs_27_5
                }
            ],
            in_atv: [
                {
                    act: "Night Camp Fire With Music"
                }
            ],
            in_visit: [
                {
                    vi_img: manjarabadfort,
                    vi_text: "Manjarabad Fort"
                },
                {
                    vi_img: agniguda,
                    vi_text: "Agni Gudda Hill"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur / Halebidu"
                },
                {
                    vi_img: BisleViewPoint,
                    vi_text: "Bisle Ghat"
                }
            ]
        }
    },
    {
        code: "28",
        name: "Oxyzone Homestay",
        location:"koukodi, Sakleshpur.",
        image: hs_28_3,
        facility: "Fun Activities, Food, Hot Water, Awesome View, Extra Beds",
        details: {
            in_name: "Oxyzone Homestay",
            in_location: "koukodi, Sakleshpur.",
            in_desc: "Located in the midst of the valleys of Kodagu, hidden deep is a lush green coffee estate, Oxyzone offers a blend of modern and medieval architecture homestay. Oxyzone is located in the north part of Coorg amidst the western ghats which are known for its flora and fauna. If you are looking to rejuvenate and relax away from the hustle and bustle of the city life then we’re here for you!  At Oxyzone we believe that a holiday is an experience where your soul connects with nature, immersing yourselves in the fresh mountain air, waking up to the chatter of birds, sipping home-grown coffee or your fave beverage, indulge yourself in our authentic Malnad cuisine. Let your body and mind relax and recuperate from the stress of city life. The only sounds you hear are the songs of the birds, the whisper of the wind and trees. For nature and animal/bird lovers, we have Turkeys, Emus, Pigeons, Ducks, Turtle, fishes in the pond and dogs. They are friendly pets and love everyone who visits our stay. We believe in making our guests feel home away from home and our meals served is home-cooked, healthy, hygienic and wholesome.",
            in_inTime: "11:00 AM",
            in_outTime: "11:00 AM",
            images: [
                {
                    in_img: hs_28_1
                },
                {
                    in_img: hs_28_2
                },
                {
                    in_img: hs_28_3
                },
                {
                    in_img: hs_28_4
                },
                {
                    in_img: hs_28_5
                },
                {
                    in_img: hs_28_6
                },
                {
                    in_img: hs_28_7
                },
                {
                    in_img: hs_28_8
                },
                {
                    in_img: hs_28_9
                }
            ],
            in_atv: [
                {
                    act: "Camping"
                },
                {
                    act: "Estate Walk"
                },
                {
                    act: "Archery"
                },
                {
                    act: "Personalized Events"
                },
                {
                    act: "Air Rifle Shooting"
                },
                {
                    act: "Board Games"
                },
                {
                    act: "Fire Place"
                },
                {
                    act: "Music"
                },
                {
                    act: "Outdoor Games"
                },
                {
                    act: "Trekking"
                },
                {
                    act: "Fishing Feeding"
                },
                {
                    act: "Fishing Feeding"
                },
                {
                    act: "Destination Weddings"
                }
            ],
            in_visit: [
                {
                    vi_img: manjarabadfort,
                    vi_text: "Manjarabad Fort"
                },
                {
                    vi_img: agniguda,
                    vi_text: "Agni Gudda Hill"
                },
                {
                    vi_img: belur,
                    vi_text: "Belur / Halebidu"
                },
                {
                    vi_img: BisleViewPoint,
                    vi_text: "Bisle Ghat"
                }
            ]
        }
    }
]